<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <v-card class="pl-2 pr-2"> -->
        <!-- <v-col cols="12">
        </v-col> -->
        <v-row>
          <v-col cols="12">
            <app-headline :title="title" class="mb-2" />
            <leave-approve-filter :title="title" />
          </v-col>

          <v-col cols="12">
            <app-headline title="ผลการค้นหา" class="mb-2" />
            <leave-approve-table />
          </v-col>
        </v-row>

        <!-- </v-card> -->
      </v-container>
    </v-main>
  </div>
</template>

<script>
import LeaveApproveFilter from '@/components/leave/LeaveApprove/LeaveApproveFilter'
import LeaveApproveTable from '@/components/leave/LeaveApprove/LeaveApproveTable'

export default {
  components: {
    LeaveApproveFilter,
    LeaveApproveTable
  },

  data() {
    return {
      empInfo: {}
    }
  },

  computed: {
    title() {
      const txt = 'รายการเห็นชอบหรืออนุญาตการลาของ '
      let name = ''

      if (this.$isSelf) {
        name = this.$username
      } else {
        name = this.empInfo[`employeeName${this.$lang}`] || ''
      }
      return txt + name
    }
  },

  async mounted() {
    if (!this.$isSelf) {
      this.empInfo = (await this.apiGetEmpName()) || {}
    }
  },

  methods: {
    async apiGetEmpName() {
      try {
        const res = await this.$store.dispatch('user/getInfo', this.$guid)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
